<template>
    <span class="badge" :class="[{'badge-pill': pill, 'badge-uppercase': uppercase, 'badge-small': small, 'badge-closable': closable}, 'badge-'+type]">
        <span><slot></slot></span>
        <i v-if="closable" class="zmdi zmdi-close zmdi-hc-fw" @click.stop="close"></i>
    </span>
</template>

<script>
    export default {
        props: {
            pill: Boolean,
            type: {type: String, default: ''},
            closable: Boolean,
            uppercase: Boolean,
            small: Boolean
        },

        methods: {
            close(event) {
                this.$emit('close',event);
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_badge.scss";</style>